/*
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description:
 */
const RootPath = window.g.baseUrl
const apis = {
  /* 送货 api */
  getSendOrderList: RootPath + 'plugin/delivery/delivery/GetDeliveryList',
  delSendOrderList: RootPath + 'plugin/delivery/delivery/DelDeliveryList',
  getDeliveryForm: RootPath + 'plugin/delivery/delivery/GetDeliveryForm',
  saveDeliveryForm: RootPath + 'plugin/delivery/delivery/SaveDeliveryForm',
  getProductTable: RootPath + 'plugin/delivery/delivery/GetProductTable',
  getProductPage: RootPath + 'plugin/delivery/delivery/GetProductPage',
  getProductPageNoTableNumber: RootPath + 'plugin/delivery/delivery/GetProductPageNoTableNumber',
  getCompanyName: RootPath + 'plugin/delivery/delivery/GetCompanyName',
  getDeliveryNumberList: RootPath + 'plugin/delivery/delivery/GetDeliveryNumberList'
}

export default apis
